import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  Button,
  Grid,
  Box,
  Typography,
} from '@mui/material';
import ReactPerfectScrollbar from 'react-perfect-scrollbar';
import GetAppIcon from '@mui/icons-material/GetApp';
import VisibilityIcon from '@mui/icons-material/Visibility';

const ReusableTable = ({
  data = [],
  columns,
  headers = [],
  paginatedData,
  handleView,
  handleEdit,
  pdfData,
  redirectToBooking,
  handleOpenPopup,
  renderDeleteButton,
  renderEditButton,
  handleDownloadPDF,
  title,
}) => {
  const tableHeaders = headers && headers.length > 0 ? headers : columns;

  return (
    <TableContainer component={Paper} sx={{ overflowY: 'hidden' }}>
      <ReactPerfectScrollbar>
        <Table>
          <TableHead>
            <TableRow>
              {tableHeaders.map((col) => (
                <TableCell key={col.field} className='table-fonts'>
                  {col.header}
                </TableCell>
              ))}
              {(handleView || handleEdit || handleOpenPopup) && (
                <TableCell>Actions</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData && paginatedData.length > 0 ? (
              paginatedData.map((item) => (
                <TableRow key={item.id}>
                  {tableHeaders.map((col) => (
                    <TableCell key={col.field} className='table-cell-fonts'>
                      {col.render
                        ? col.render(item[col.field], item)
                        : item[col.field] || 'N/A'}
                    </TableCell>
                  ))}
                  {(handleView || handleEdit || handleOpenPopup) && (
                    <TableCell>
                      <Box className='button-list'>
                        {handleView && (
                          <Grid>
                            <Button
                              variant='outlined'
                              color='warning'
                              size='small'
                              onClick={() => handleView(item)}
                              className='view-user-button'
                            >
                              VIEW
                            </Button>
                          </Grid>
                        )}
                        {handleEdit && (
                          <Grid item>
                            <Button
                              variant='outlined'
                              color='primary'
                              size='small'
                              onClick={() => handleEdit(item)}
                              className='edit-user-button'
                            >
                              EDIT
                            </Button>
                          </Grid>
                        )}

                        {handleDownloadPDF && (
                          <Grid>
                            <Button
                              variant='outlined'
                              color='info'
                              size='small'
                              startIcon={<GetAppIcon />}
                              onClick={() => handleDownloadPDF(item)}
                              className='orange-button'
                            >
                              PDF
                            </Button>
                          </Grid>
                        )}
                        {title === 'Bookings' && handleOpenPopup && (
                          <Grid item>
                            {renderEditButton ? (
                              renderEditButton(item, handleOpenPopup)
                            ) : (
                              <Button
                                variant='outlined'
                                color='error'
                                size='small'
                                onClick={() => handleOpenPopup(item)}
                                className='edit-user-button'
                              >
                                EDIT
                              </Button>
                            )}
                          </Grid>
                        )}
                        {handleOpenPopup && (
                          <Grid item>
                            {renderDeleteButton ? (
                              renderDeleteButton(item, handleOpenPopup)
                            ) : (
                              <Button
                                variant='outlined'
                                color='error'
                                size='small'
                                onClick={() => handleOpenPopup(item)}
                                className='delete-user-button'
                              >
                                DELETE
                              </Button>
                            )}
                          </Grid>
                        )}

                        {title === 'Customer' && handleOpenPopup && (
                          <Grid item>
                            <Button
                              variant='outlined'
                              size='small'
                              onClick={() => redirectToBooking(item)}
                              className='booknow-orange-button'
                            >
                              Book Now
                            </Button>
                          </Grid>
                        )}
                      </Box>
                    </TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={tableHeaders.length + 1}>
                  <Typography
                    align='center'
                    color='textSecondary'
                    sx={{ py: 3 }}
                  >
                    No data available
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </ReactPerfectScrollbar>
    </TableContainer>
  );
};

export default ReusableTable;
